import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ListNormalOnboarding from "./ListingNormal";
import { getCarnivalList, getNormalOnBoardingListing } from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
  carnivalList: state.ConductCampReducer.carnivalList,
  normalOnboardingListing: state.ConductCampReducer.normalOnboardingListing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCarnivalList,
      getNormalOnBoardingListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ListNormalOnboarding);
